import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ErrorBoundary from "lib/ErrorBoundary";
import { _t } from "app/i18n/i18n";
import { useFetchParse } from "../../lib/hooks/useFetchParse";
import { LoadingSpinner } from "../../lib/Spinner";
import { DataErrorMsg } from "../analystDirectory/AnalystDirectory";
import { useProdCopyUrl } from "../redesign/preferences/redesignUtils";
import { copyToClipboard } from "./copyToClipboard";
import { createSearchQuery, getContentBody } from "./createSearchQuery";

export const CopyTextModal = ({ modalShow, setModalShow, publication }) => {
  const url = `/research/${useProdCopyUrl()}/pub/search/query`;
  const query = createSearchQuery(publication.id);
  const [body, isLoading, isError] = useFetchParse(url, JSON.stringify(query), "POST", true, getContentBody);

  const [isButtonEnabled, setButtonEnabled] = useState(true);
  const onHide = () => setModalShow(false);

  const onCopyButtonClick = (ev) => {
    ev.stopPropagation();
    copyToClipboard(publication.title + " " + body);
    setButtonEnabled(false);
  };

  return (
    <ErrorBoundary>
      <Modal scrollable size="lg" centered show={modalShow} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>{isLoading ? _t("Loading...") : publication.title || ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-y-auto maxh-60vh">
          {isLoading ? (
            <LoadingSpinner />
          ) : isError ? (
            <DataErrorMsg />
          ) : !body ? (
            _t("The text copy feature is not available for this publication")
          ) : (
            body
          )}
        </Modal.Body>
        <Modal.Footer>
          <a href="http://intranet.nomuranow.com/nomuchat/#message_text" target="nomuchat">
            {_t("Go to Nomuchat")}
          </a>
          <Button variant="primary" onClick={onCopyButtonClick} disabled={!isButtonEnabled || !body}>
            {_t("Copy text to clipboard")}
          </Button>
          <Button variant="secondary" onClick={onHide}>
            {_t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </ErrorBoundary>
  );
};
